export default "__VITE_ASSET__C8Cy6u50__"